import React, { Component } from "react";
import {
  Segment,
  Grid,
  Header,
  Container,
  Card,
  Image,
  Icon,
  Divider,
  Button,
  Responsive
} from "semantic-ui-react";
import Slider from "react-slick";
import ModalProdutoComponent from "./ModalProdutoComponent";

import imgRedeProtecao1 from "./../static/rede-protecao-1.jpg";
import imgRedeProtecao2 from "./../static/rede-protecao-2.jpg";
import imgRedeProtecao3 from "./../static/rede-protecao-3.png";

import produtosJson from "./produtos";
import ModalRedeComponent from "./ModalRedeComponent";

import seloAbnt from "./../static/abnt.png";
import seloFalcaoBauer from "./../static/falcao_bauer.jpg";
import seloIso9002 from "./../static/iso9002.jpeg";

import varalSanfonado from "./../static/varal-sanfonado.png";
import varalTradicional from "./../static/varal-tradicional.png";
import varalTradicionalParede from "./../static/varal-tradicional-parede.png";

import colors from "../js/colors";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div onClick={onClick}>
      <button className={"slick-arrow slick-next"}>
        <Icon name="angle right" size="big" style={{ color: "black" }} />
      </button>
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div onClick={onClick}>
      <button className={"slick-arrow slick-prev"}>
        <Icon name="angle left" size="big" style={{ color: "black" }} />
      </button>
    </div>
  );
}

const settings = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  className: "slick-produtos-custom",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        arrows: false
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
};

const styles = {
  varaisIconLabel: {
    fontWeight: "bold",
    color: colors.medium
  },
  redesIconLabel: {
    fontWeight: "bold",
    color: colors.mediumDark
  }
};
export default class ProdutosComponent extends Component {
  state = {
    modalRedes: {
      show: false,
      tecInfo: false
    },
    modalProdutos: {
      show: false,
      element: null
    }
  };

  openModal = (modal, element, tecInfo) => {
    this.setState({
      [modal]: {
        show: true,
        element: element ? Object.assign({}, element) : null,
        tecInfo: tecInfo
      }
    });
  };

  closeModal = modal => {
    this.setState({ [modal]: { show: false, element: Object.assign({}, {}) } });
  };

  render() {
    return (
      <Container fluid>
        <Segment vertical style={{ paddingTop: "150px" }}>
          <Container style={{ paddingBottom: "50px" }}>
            <Header as="h3" style={{ color: colors.medium }}>
              Varais e Acessórios
            </Header>

            <Grid
              stackable
              centered
              columns="equal"
              style={{ marginTop: 50, marginBottom: 50 }}
            >
              <Grid.Column>
                <Segment>
                  <Grid
                    stackable
                    style={{ height: 150 }}
                    className="one-edge-shadow"
                  >
                    <Grid.Row
                      columns="equal"
                      textAlign="center"
                      verticalAlign="middle"
                    >
                      <Grid.Column>
                        <Icon name="thumbs up" size="big" className="custom" />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal" textAlign="center">
                      <Grid.Column>
                        <p style={styles.varaisIconLabel}>
                          Qualidade garantida!
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment>
                  <Grid
                    stackable
                    style={{ height: 150 }}
                    className="one-edge-shadow"
                  >
                    <Grid.Row
                      columns="equal"
                      textAlign="center"
                      verticalAlign="middle"
                    >
                      <Grid.Column>
                        <Icon
                          name="dollar sign"
                          size="big"
                          className="custom"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal" textAlign="center">
                      <Grid.Column>
                        <p style={styles.varaisIconLabel}>
                          Melhor custo x benefício
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment>
                  <Grid
                    stackable
                    style={{ height: 150 }}
                    className="one-edge-shadow"
                  >
                    <Grid.Row
                      columns="equal"
                      textAlign="center"
                      verticalAlign="middle"
                    >
                      <Grid.Column>
                        <Icon
                          name="check square outline"
                          size="big"
                          className="custom"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal" textAlign="center">
                      <Grid.Column>
                        <p style={styles.varaisIconLabel}>
                          Profissionais que entendem do assunto
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment>
                  <Grid
                    stackable
                    style={{ height: 150 }}
                    className="one-edge-shadow"
                  >
                    <Grid.Row
                      columns="equal"
                      textAlign="center"
                      verticalAlign="middle"
                    >
                      <Grid.Column>
                        <Icon
                          name="pencil alternate"
                          size="big"
                          className="custom"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal" textAlign="center">
                      <Grid.Column>
                        <p style={styles.varaisIconLabel}>
                          Feito na medida que você precisa!
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
            </Grid>

            <Header as="h4">
              Temos uma grande linha de varais de alta qualidade, com ótimo
              acabamento e muita praticidade em seu manuseio, deixando sua
              utilização mais fácil e seu espaço mais bonito e funcional.
              Trabalhamos com profissionais treinados , mão de obra
              especializada em materiais de alta qualidade, para garantir sempre
              os melhores serviços com rapidez e eficiência.
            </Header>

            <Grid
              stackable
              centered
              columns="equal"
              style={{ marginBottom: 50, marginTop: 50 }}
            >
              <Grid.Column>
                <Card
                  style={{ width: "100%", maxHeight: "508", maxWidth: "400px" }}
                >
                  <Image
                    fluid
                    src={varalSanfonado}
                    className="one-edge-shadow"
                  />
                </Card>
              </Grid.Column>

              <Grid.Column>
                <Card
                  style={{ width: "100%", maxHeight: "508", maxWidth: "400px" }}
                >
                  <Image
                    fluid
                    src={varalTradicional}
                    className="one-edge-shadow"
                  />
                </Card>
              </Grid.Column>
              <Grid.Column>
                <Card
                  style={{ width: "100%", maxHeight: "508", maxWidth: "400px" }}
                >
                  <Image
                    fluid
                    src={varalTradicionalParede}
                    className="one-edge-shadow"
                  />
                </Card>
              </Grid.Column>
            </Grid>

            <Grid
              stackable
              centered
              columns="equal"
              style={{ marginBottom: 100, marginTop: 100 }}
            >
              <Grid.Column textAlign="center">
                <Header as="h2" style={{ color: colors.mediumDark }}>
                  Especialistas em Varais no Gesso
                </Header>

                <Header as="h3" style={{ color: colors.mediumDark }}>
                  Não tenha medo de ter o seu varal por conta de instalação no
                  gesso. Faça um orçamento conosco agora mesmo!
                </Header>
              </Grid.Column>
            </Grid>

            <section id="section-linha-produtos">
              <Header as="h4" style={{ marginBottom: 50 }}>
                Linha de produtos:
              </Header>
            </section>

            <Slider {...settings}>
              {produtosJson.map((element, index) => (
                <div key={`slider-card-${index}`} className="one-edge-shadow">
                  <Card
                    style={{
                      width: "100%",
                      maxHeight: "508",
                      maxWidth: "400px"
                    }}
                  >
                    <Image fluid src={element.imageDefault} />
                    <Card.Content textAlign="center">
                      <Responsive maxWidth={Responsive.onlyTablet.maxWidth}>
                        <Card.Description as="h5" style={{ color: "black" }}>
                          {element.title}
                        </Card.Description>
                      </Responsive>
                      <Responsive minWidth={Responsive.onlyComputer.minWidth}>
                        <Card.Description as="h4" style={{ color: "black" }}>
                          {element.title}
                        </Card.Description>
                      </Responsive>
                    </Card.Content>
                  </Card>
                </div>
              ))}
            </Slider>
          </Container>

          <Container
            style={{ marginTop: 50, marginBottom: 50, paddingBottom: "50px" }}
          >
            <section id="section-redes-protecao">
              <Header as="h3" style={{ color: colors.mediumDark }}>
                Redes de Proteção
              </Header>
            </section>

            <Grid
              stackable
              centered
              columns="equal"
              style={{ marginTop: 50, marginBottom: 50 }}
            >
              <Grid.Column>
                <Segment>
                  <Grid
                    stackable
                    style={{ height: 150 }}
                    className="one-edge-shadow"
                  >
                    <Grid.Row
                      columns="equal"
                      textAlign="center"
                      verticalAlign="middle"
                    >
                      <Grid.Column>
                        <Icon name="heart" size="big" className="custom red" />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal" textAlign="center">
                      <Grid.Column>
                        <p style={styles.redesIconLabel}>
                          Nosso principal objetivo é sua segurança
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment>
                  <Grid
                    stackable
                    style={{ height: 150 }}
                    className="one-edge-shadow"
                  >
                    <Grid.Row
                      columns="equal"
                      textAlign="center"
                      verticalAlign="middle"
                    >
                      <Grid.Column>
                        <Icon
                          name="thumbs up"
                          size="big"
                          className="custom red"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal" textAlign="center">
                      <Grid.Column>
                        <p style={styles.redesIconLabel}>
                          Garantia e Qualidade da Varais Alpha
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment>
                  <Grid
                    stackable
                    style={{ height: 150 }}
                    className="one-edge-shadow"
                  >
                    <Grid.Row
                      columns="equal"
                      textAlign="center"
                      verticalAlign="middle"
                    >
                      <Grid.Column>
                        <Icon
                          name="certificate"
                          size="big"
                          className="custom red"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal" textAlign="center">
                      <Grid.Column>
                        <p style={styles.redesIconLabel}>
                          {"Produtos testados & certificados"}
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment>
                  <Grid
                    stackable
                    style={{ height: 150 }}
                    className="one-edge-shadow"
                  >
                    <Grid.Row
                      columns="equal"
                      textAlign="center"
                      verticalAlign="middle"
                    >
                      <Grid.Column>
                        <Icon
                          name="handshake"
                          size="big"
                          className="custom red"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns="equal" textAlign="center">
                      <Grid.Column>
                        <p style={styles.redesIconLabel}>
                          Melhor negócio para a segurança de toda sua família
                        </p>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
            </Grid>

            <Header as="h4">
              A Varais Alpha disponibiliza redes de proteção confeccionadas a
              partir de materiais com alta durabilidade e resistência Todas as
              nossas redes são feitas 100% de polietileno e com tratamento Anti
              U.V que reflete os raios ultravioletas aumentando a vida útil das
              redes de proteção.
            </Header>

            <Grid
              stackable
              centered
              columns="equal"
              style={{ marginBottom: 50, marginTop: 50 }}
            >
              <Grid.Column>
                <Card
                  style={{ width: "100%", maxHeight: "508", maxWidth: "400px" }}
                >
                  <Image
                    fluid
                    src={imgRedeProtecao1}
                    className="one-edge-shadow"
                  />
                </Card>
              </Grid.Column>

              <Grid.Column>
                <Card
                  style={{ width: "100%", maxHeight: "508", maxWidth: "400px" }}
                >
                  <Image
                    fluid
                    src={imgRedeProtecao2}
                    className="one-edge-shadow"
                  />
                </Card>
              </Grid.Column>
              <Grid.Column>
                <Card
                  style={{ width: "100%", maxHeight: "508", maxWidth: "400px" }}
                >
                  <Image
                    fluid
                    src={imgRedeProtecao3}
                    className="one-edge-shadow"
                  />
                </Card>
              </Grid.Column>
            </Grid>

            <Grid stackable centered columns="equal">
              <Button
                primary
                size="big"
                icon
                labelPosition="left"
                style={{ marginTop: "10px", backgroundColor: colors.medium }}
                onClick={() => this.openModal("modalRedes", null, true)}
              >
                <Icon name="info" size="small" className="white" />
                Informações Técnicas
              </Button>
            </Grid>
          </Container>

          <Container style={{ marginBottom: 50 }}>
            <Header as="h3" style={{ marginBottom: 50 }}>
              Selos e Certificados
            </Header>
            <Header as="h4" style={{}}>
              Trabalhamos com os melhores materiais e profissionais, com
              produtos certificados pelas seguintes instituições:
            </Header>
            <Divider />
            <Grid
              stackable
              columns="equal"
              style={{ marginBottom: 50, marginTop: 50 }}
            >
              <Grid.Column>
                {/* <Card style={{ width: '100%', maxHeight: '508', maxWidth: '400px' }}> */}
                <Image
                  fluid
                  src={seloAbnt}
                  style={{ maxHeight: 112, objectFit: "contain" }}
                />
                {/* </Card> */}
              </Grid.Column>

              <Grid.Column>
                {/* <Card style={{ width: '100%', maxHeight: '508', maxWidth: '400px' }}> */}
                <Image
                  fluid
                  src={seloFalcaoBauer}
                  style={{ maxHeight: 112, objectFit: "contain" }}
                />
                {/* </Card> */}
              </Grid.Column>

              <Grid.Column>
                {/* <Card style={{ width: '100%', maxHeight: '508', maxWidth: '400px' }}> */}
                <Image
                  fluid
                  src={seloIso9002}
                  style={{ maxHeight: 112, objectFit: "contain" }}
                />
                {/* </Card> */}
              </Grid.Column>
            </Grid>
          </Container>
        </Segment>

        <ModalProdutoComponent
          open={this.state.modalProdutos.show}
          element={this.state.modalProdutos.element}
          closeModal={this.closeModal}
        />
        <ModalRedeComponent
          open={this.state.modalRedes.show}
          tecInfo={this.state.modalRedes.tecInfo}
          closeModal={this.closeModal}
        />
      </Container>
    );
  }
}
